import { render, staticRenderFns } from "./BasePageComponent.vue?vue&type=template&id=214fcec4&"
import script from "./BasePageComponent.vue?vue&type=script&lang=js&"
export * from "./BasePageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/BasePageComponent.vue
// module id = null
// module chunks = 